const easeInOutSine = pos => -0.5 * (Math.cos(Math.PI * pos) - 1)

class Tween {
  constructor() {
    this.durationTime = 0
    this.easingFn = k => k
    this.eventHandlers = new Map()
  }

  easing(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Easing must be a function, such as k => k')
    }

    this.easingFn = fn
    return this
  }

  duration(time) {
    if (typeof time !== 'number') {
      throw new Error('Duration must be a number')
    }

    this.durationTime = time
    return this
  }

  on(type, handler) {
    if (typeof handler !== 'function') {
      throw new Error('Handler must be a function')
    }

    this.eventHandlers.set(type, handler)
    return this
  }

  animate() {
    const duration = this.durationTime
    const easing = this.easingFn
    const update = this.eventHandlers.get('update') || (t => t)
    const complete = this.eventHandlers.get('complete') || (() => {})

    let timer = null
    const startTime = +new Date()

    function step() {
      const percent = Math.min(1, (+new Date() - startTime) / duration)

      if (percent < 1) {
        update(easing(percent))
        timer = requestAnimationFrame(step)
      } else {
        cancelAnimationFrame(timer)
        update(easing(1))
        complete()
      }
    }

    timer = requestAnimationFrame(step)
  }
}

export { easeInOutSine, Tween }
